import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getPatientsByMobile } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useAuth } from "../../../contexts/auth-context";

export function usePatientsByMobile({
  enabled = true,
  selectPatient,
}: {
  enabled?: boolean;
  selectPatient?: (patient: string) => void;
}) {
  const { toast } = useToast();

  const { mobile } = useAuth();

  const {
    data: patients,
    isLoading,
    isError,
    isFetched,
    isSuccess,
  } = useQuery({
    queryKey: ["patients", mobile],
    queryFn: () => getPatientsByMobile(mobile),
    enabled: !!mobile && enabled,
  });

  useEffect(() => {
    const selectedPatient = localStorage.getItem("selectedPatient");
    if (isSuccess && !selectedPatient && patients?.length) {
      localStorage.setItem("selectedPatient", patients[0].name);
      selectPatient?.(patients[0].name);
    }
  }, [isSuccess, patients, selectPatient]);

  useEffect(() => {
    if (isError) {
      toast({
        title: "Failed to fetch patients",
        variant: "destructive",
      });
    }
  }, [isError, toast]);

  return { patients, isLoading, isFetched };
}
